import api from '../utils/api';
import { GET_DATA, SET_BUILDING_DASHBOARD, SET_FLOOR_DASHBOARD, SET_PROJECT_DASHBOARD } from './types';


// Initial Data load
export const loadData = (params) => async (dispatch) => {
  try {
    const { data } = await api.get(`/data?${params}`);
    dispatch({ type: GET_DATA, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const setProject = (data) => (dispatch) => {
  dispatch({ type: SET_BUILDING_DASHBOARD, payload: null });
  dispatch({ type: SET_PROJECT_DASHBOARD, payload: data });
};

export const setBuilding = (data) => (dispatch) => {
  dispatch({ type: SET_FLOOR_DASHBOARD, payload: null });
  dispatch({ type: SET_BUILDING_DASHBOARD, payload: data });
};

export const setFloor = (data) => (dispatch) => {
  dispatch({ type: SET_FLOOR_DASHBOARD, payload: data });
};
